module.exports = __webpack_public_path__ + "static/media/FooterLogo.4f5d3a33.png";